import { getCarConfig, getUpgradeConfig } from '../Common/GameConfig';
import { GamePlayerTypeEnum, PlayerRoadIndexEnum } from './GameModel';
import { IBackendGameCarStateUpgrade } from '../Backend';

export enum PaintEnum {
    green,
    red,
    blue,
    purple
}

export class CarModel {
    public index: number = 0;

    public gasRate: number = 1;
    public health: number = 100;
    public repairPrice: number = 200;

    public speedFriction: number = 50;
    public speedMax: number = 3000;
    public speedAcceleration: number = 1;
    public speed: number = 0;
    public brakeSpeed: number = 50;


    public type: GamePlayerTypeEnum = GamePlayerTypeEnum.vaz;
    public isBought = false;
    public price = 0;
    public name: string = "";

    public upgrades: IBackendGameCarStateUpgrade[] = [0, 0, 0, 0];
    public availablePaints: boolean[] = [false, false, false, false];
    public paint: PaintEnum = 0;

    constructor(index: number) {
        this.index = index;

        this.price = getCarConfig(index, 'price');
        this.speedAcceleration = getCarConfig(index, 'acceleration');
        this.speedMax = getCarConfig(index, 'speed');
        this.gasRate = getCarConfig(index, 'gasRate');
        this.repairPrice = getCarConfig(index, 'repairPrice');
        this.type = Object.values(GamePlayerTypeEnum)[index + 1];
        this.name = getCarConfig(index, 'title');

        this.updateProperties();

        this.availablePaints[0] = true;
        this.availablePaints[1] = true;
    }

    public updateProperties(): void {
        this.speedMax = getCarConfig(this.index, 'speed');
        this.speedAcceleration = getCarConfig(this.index, 'acceleration');
        this.gasRate =  getCarConfig(this.index, 'gasRate');

        for (let i = 0; i < this.upgrades.length; i++) {
            const upgradeIndex = +(this.upgrades[i]);

            if (upgradeIndex > 0) {
                this.speedMax += getUpgradeConfig(upgradeIndex, 'maxSpeed');
                this.speedAcceleration += getUpgradeConfig(upgradeIndex, 'acceleration');
                this.gasRate += getUpgradeConfig(upgradeIndex, 'fuelRate');
            }
        }
    }

    public reset() {
        this.speed = 0;
    }
}
